/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { GetAlternativesResponse } from '../models/GetAlternativesResponse';
import type { GetPairingStatusResponse } from '../models/GetPairingStatusResponse';
import type { OnboardingFlowResponse } from '../models/OnboardingFlowResponse';
import type { ResendOTPChallengeResponse } from '../models/ResendOTPChallengeResponse';
import type { StartOnboardingRequest } from '../models/StartOnboardingRequest';
import type { StartPairingResponse } from '../models/StartPairingResponse';
import type { SubmitOnboardingRequest } from '../models/SubmitOnboardingRequest';
import type { user_portal_api__schemas__onboarding_schemas__ChooseAuthenticatorRequest } from '../models/user_portal_api__schemas__onboarding_schemas__ChooseAuthenticatorRequest';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class OnboardingService {
    /**
     * Start onboarding flow for a user.
     *
     * Creates a session cookie and returns the first step (SMS verification).
     *
     * Args:
     * request: Start onboarding request with the magic-link token
     * response: FastAPI response for setting cookies
     * metadata: Request metadata (ip_address, user_agent, request_id)
     * session_service: Onboarding session service (injected)
     *
     * Returns:
     * OnboardingFlowResponse with status, has_alternative, and current_step
     *
     * Start onboarding flow for a user.
     *
     * Creates a session cookie and returns the first step (SMS verification).
     *
     * Args:
     * request: Start onboarding request with the magic-link token
     * response: FastAPI response for setting cookies
     * metadata: Request metadata (ip_address, user_agent, request_id)
     * session_service: Onboarding session service (injected)
     *
     * Returns:
     * OnboardingFlowResponse with status, has_alternative, and current_step
     * @param requestBody
     * @returns OnboardingFlowResponse Successful Response
     * @throws ApiError
     */
    public static startOnboarding(
        requestBody: StartOnboardingRequest,
    ): CancelablePromise<OnboardingFlowResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/onboarding/start',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Submit factor response in onboarding flow.
     *
     * Uses session cookie to identify flow/step. Updates session on success.
     *
     * Args:
     * request: Submit request with factor payload
     * response: FastAPI response for updating cookies
     * validated_session: Validated onboarding session from cookie
     * metadata: Request metadata
     * session_service: Onboarding session service (injected)
     *
     * Returns:
     * OnboardingFlowResponse with status and next step
     *
     * Submit factor response in onboarding flow.
     *
     * Uses session cookie to identify flow/step. Updates session on success.
     *
     * Args:
     * request: Submit request with factor payload
     * response: FastAPI response for updating cookies
     * validated_session: Validated onboarding session from cookie
     * metadata: Request metadata
     * session_service: Onboarding session service (injected)
     *
     * Returns:
     * OnboardingFlowResponse with status and next step
     * @param requestBody
     * @param onboardingSession
     * @returns OnboardingFlowResponse Successful Response
     * @throws ApiError
     */
    public static submitOnboarding(
        requestBody: SubmitOnboardingRequest,
        onboardingSession?: (string | null),
    ): CancelablePromise<OnboardingFlowResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/onboarding/submit',
            cookies: {
                'onboarding_session': onboardingSession,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Get Alternative Authenticators
     * Get the alternative authenticators for the onboarding flow
     * @param onboardingSession
     * @returns GetAlternativesResponse Successful Response
     * @throws ApiError
     */
    public static getAlternatives(
        onboardingSession?: (string | null),
    ): CancelablePromise<GetAlternativesResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/onboarding/authenticator-alternatives',
            cookies: {
                'onboarding_session': onboardingSession,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Resend OTP challenge - automatically routes to SMS or WhatsApp.
     *
     * The factor type is read from the session's current_step_factor_type field,
     * which was stored when the flow started or progressed to this step.
     *
     * Args:
     * validated_session: Validated onboarding session from cookie
     * metadata: Request metadata
     * session_service: Onboarding session service (injected)
     *
     * Returns:
     * ResendOTPChallengeResponse with success status
     *
     * Resend OTP challenge - automatically routes to SMS or WhatsApp.
     *
     * The factor type is read from the session's current_step_factor_type field,
     * which was stored when the flow started or progressed to this step.
     *
     * Args:
     * validated_session: Validated onboarding session from cookie
     * metadata: Request metadata
     * session_service: Onboarding session service (injected)
     *
     * Returns:
     * ResendOTPChallengeResponse with success status
     * @param onboardingSession
     * @returns ResendOTPChallengeResponse Successful Response
     * @throws ApiError
     */
    public static resendOtp(
        onboardingSession?: (string | null),
    ): CancelablePromise<ResendOTPChallengeResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/onboarding/otp/resend',
            cookies: {
                'onboarding_session': onboardingSession,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Complete onboarding when user is satisfied with enrollment.
     *
     * This endpoint allows users to explicitly complete onboarding even when
     * unenrolled alternative factors remain. Policy tree must be satisfied.
     *
     * Used when UI shows "Complete" button (canComplete=true).
     * Clears the onboarding session cookie upon completion.
     *
     * Args:
     * response: FastAPI response for clearing cookies
     * validated_session: Validated onboarding session from cookie
     * metadata: Request metadata
     * session_service: Onboarding session service (injected)
     *
     * Returns:
     * OnboardingFlowResponse with COMPLETED status
     *
     * Raises:
     * HTTPException: If policy tree not yet satisfied
     *
     * Complete onboarding when user is satisfied with enrollment.
     *
     * This endpoint allows users to explicitly complete onboarding even when
     * unenrolled alternative factors remain. Policy tree must be satisfied.
     *
     * Used when UI shows "Complete" button (canComplete=true).
     * Clears the onboarding session cookie upon completion.
     *
     * Args:
     * response: FastAPI response for clearing cookies
     * validated_session: Validated onboarding session from cookie
     * metadata: Request metadata
     * session_service: Onboarding session service (injected)
     *
     * Returns:
     * OnboardingFlowResponse with COMPLETED status
     *
     * Raises:
     * HTTPException: If policy tree not yet satisfied
     * @param onboardingSession
     * @returns OnboardingFlowResponse Successful Response
     * @throws ApiError
     */
    public static completeOnboarding(
        onboardingSession?: (string | null),
    ): CancelablePromise<OnboardingFlowResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/onboarding/complete',
            cookies: {
                'onboarding_session': onboardingSession,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Choose an authenticator from available alternatives.
     *
     * Called when user selects a specific factor from the alternatives list.
     * Validates the choice, initiates the factor's challenge, and updates the session.
     *
     * Args:
     * request: Choose authenticator request with authenticator type
     * response: FastAPI response for updating cookies
     * validated_session: Validated onboarding session from cookie
     * metadata: Request metadata
     * session_service: Onboarding session service (injected)
     *
     * Returns:
     * OnboardingFlowResponse with the new challenge for the chosen authenticator
     *
     * Choose an authenticator from available alternatives.
     *
     * Called when user selects a specific factor from the alternatives list.
     * Validates the choice, initiates the factor's challenge, and updates the session.
     *
     * Args:
     * request: Choose authenticator request with authenticator type
     * response: FastAPI response for updating cookies
     * validated_session: Validated onboarding session from cookie
     * metadata: Request metadata
     * session_service: Onboarding session service (injected)
     *
     * Returns:
     * OnboardingFlowResponse with the new challenge for the chosen authenticator
     * @param requestBody
     * @param onboardingSession
     * @returns OnboardingFlowResponse Successful Response
     * @throws ApiError
     */
    public static chooseAuthenticator(
        requestBody: user_portal_api__schemas__onboarding_schemas__ChooseAuthenticatorRequest,
        onboardingSession?: (string | null),
    ): CancelablePromise<OnboardingFlowResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/onboarding/choose-authenticator',
            cookies: {
                'onboarding_session': onboardingSession,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Start Device Pairing (Onboarding)
     * Start a device pairing flow during onboarding (uses onboarding session)
     * @param onboardingSession
     * @returns StartPairingResponse Successful Response
     * @throws ApiError
     */
    public static startOnboardingDevicePairing(
        onboardingSession?: (string | null),
    ): CancelablePromise<StartPairingResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/onboarding/device/start-pair',
            cookies: {
                'onboarding_session': onboardingSession,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Get Device Pairing Status (Onboarding)
     * Get the status of a device pairing session during onboarding (uses onboarding session)
     * @param pairingCode
     * @param onboardingSession
     * @returns GetPairingStatusResponse Successful Response
     * @throws ApiError
     */
    public static getOnboardingDevicePairingStatus(
        pairingCode: string,
        onboardingSession?: (string | null),
    ): CancelablePromise<GetPairingStatusResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/onboarding/device/status/{pairing_code}',
            path: {
                'pairing_code': pairingCode,
            },
            cookies: {
                'onboarding_session': onboardingSession,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
}
